import { render, staticRenderFns } from "./ImportCourses.vue?vue&type=template&id=85909f04&"
import script from "./ImportCourses.vue?vue&type=script&lang=js&"
export * from "./ImportCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports